import { Link } from "react-router-dom";

const CompletedCourse = ({ntfcn}) => {
    return (
        <>
            <div className="user-body">
                <div className="user-header">
                    <div className="user-profile-img">
                        <img src={ntfcn?.course?.creator?.image} className="rounded-circle" alt={ntfcn?.course?.creator?.name} />
                    </div>
                    <div className="user-details-title">
                        <h6><Link to={`/profile-details/${ntfcn?.course?.creator?.slug}`}>{ntfcn?.course?.creator?.name}</Link><span>{ntfcn.date_time}</span></h6>
                        <p>Tutor - {ntfcn?.course?.title}</p>
                    </div>
                </div>
                <div className="user-content-block">
                    <div className="user-course-desc">
                        <p>Congratulations! You have successfully completed the <strong>{ntfcn?.course?.title}</strong> course.</p>
                    </div>
                    <div className="user-course-block">
                        <Link className="link ek-lrs-course-initialized" to={'/course-details/' + ntfcn?.course?.slug} target="_blank" data-ek-lrs-url={`/course-details/${ntfcn?.course?.slug}`} data-ek-lrs-title={ntfcn?.course?.title}>
                            <img src={ntfcn?.course?.image} alt={ntfcn?.course?.title} />
                            <span>View Certificate</span>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CompletedCourse;